import * as React from "react";
import { Card, CardContent, Typography, Box } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import CoreInfoRequestFiles from "../../CoreInfoRequestFiles";
import { CoreInfoRequestReasonType } from "../../../../Constants/Constant";

interface AttachmentsCardProps {
  classes: any;
  canEdit: boolean;
  changeRequestOrderFileType: (value: any) => void;
  selectedCoreInfoRequestFileType: number;
  onHandleFileExecute: () => Promise<void>;
  onFileGridRefresh: () => Promise<void>;
  getFileGrid: any;
  coreInfoRequestId: any;
  isFileTypeSelected: boolean;
  onFilesChange?: (files: any[]) => void;
  selectedReasons?: Number[];
  uploadedFiles?: any[];
}

const AttachmentsCard: React.FC<AttachmentsCardProps> = ({
  classes,
  canEdit,
  changeRequestOrderFileType,
  selectedCoreInfoRequestFileType,
  onHandleFileExecute,
  onFileGridRefresh,
  getFileGrid,
  coreInfoRequestId,
  isFileTypeSelected,
  onFilesChange,
  selectedReasons = [],
  uploadedFiles = [],
}) => {
  const fileTypeReasons = CoreInfoRequestReasonType.filter(
    r => r.isFileType && selectedReasons.some(s => Number(s) === r.value)
  );
  const missingFiles = fileTypeReasons.filter(
    r => !uploadedFiles.some(f => Number(f.coreInfoRequestFileType) === r.value)
  );

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography className={classes.cardTitle}>Attachments</Typography>

        {missingFiles.length > 0 && (
          <Box mb={1}>
            <Alert severity="warning">
              Missing required attachment(s): <strong>{missingFiles.map(r => r.reasonType).join(", ")}</strong>
            </Alert>
          </Box>
        )}

        <CoreInfoRequestFiles
          canEdit={canEdit}
          changeRequestOrderFileType={changeRequestOrderFileType}
          selectedCoreInfoRequestFileType={selectedCoreInfoRequestFileType}
          onHandleFileExecute={onHandleFileExecute}
          onFileGridRefresh={onFileGridRefresh}
          getFileGrid={getFileGrid}
          coreInfoRequestId={coreInfoRequestId}
          isFileTypeSelected={isFileTypeSelected}
          onFilesChange={onFilesChange}
        />
      </CardContent>
    </Card>
  );
};

export default AttachmentsCard;
